import request from './axiosInstance'

export const current = request({
  baseURL: process.env.VUE_APP_REGISTERAPI,
  headers: {
    'Content-Type': 'application/json',
    module: 'bi',
    'app-id': '6e70493db312394692779153d07ff7c5',
    version: '1',
    timestamps: '1550563990000'
  }
})

export const pcApi = request({
  baseURL: process.env.VUE_APP_PCAPI,
  headers: {
    module: 'pc',
    'app-id': '6e70493db301494692779b53f07ff7c5',
    timestamps: new Date().getTime(),
    version: '1'
  }
})

// 合同下载使用的
export const pcApiD = request({
  baseURL: process.env.VUE_APP_PC,
  headers: {
    module: 'pc',
    'app-id': '6e70493db301494692779b53f07ff7c5',
    timestamps: new Date().getTime(),
    version: '1'
  }
})

export const baseApi = request({
  // url: 'http://base-api.zhiguoguo.net'
  baseURL: process.env.VUE_APP_BASEAPI
})

export const crmApi = request({
  // url: 'https://gateway-api-staging.zhidaiyi.cn/crm-web-rest/'
  baseURL: process.env.VUE_APP_CRMAPI,
  headers: {
    'Content-Type': 'application/json',
    module: 'crm',
    'app-id': '6e70493db301494492779b53d07ff7c5',
    timestamps: new Date().getTime(),
    version: 'v0.0.1'
  }
})

export const tradeApi = request({
  baseURL: process.env.VUE_APP_TRADE
})

export const adminApi = request({
  baseURL: process.env.VUE_APP_ADMINAPI,
  headers: {
    'Content-Type': 'application/json',
    module: 'admin',
    'app-id': '6e70493db301494692779b53f07ff7c5',
    version: 'v0.0.1',
    timestamps: new Date().getTime()
  }
})

export const dataApi = request({
  baseURL: process.env.VUE_APP_DATAAPI
})

export const generalSetApi = request({
  baseURL: process.env.VUE_APP_BASEAPI,
  headers: {
    'Content-Type': 'application/json'
  }
})

export const insApi = request({
  baseURL: process.env.VUE_APP_INSAPI,
  headers: {
    'Content-Type': 'application/json',
    module: 'insurance',
    'app-id': '6e70493db301494692779ba3d07ff7c5',
    version: 'v0.0.1',
    timestamps: new Date().getTime()
  }
})

export const gwDownLoadApi = request({
  baseURL: process.env.VUE_APP_GUANWENDOWNLOAD
})

export const toolApi = request({
  baseURL: process.env.VUE_APP_TOOLAPI,
  headers: {
    module: 'toolset',
    'app-id': '6e70493db301494692779b53f07ff7c5',
    timestamps: new Date().getTime(),
    version: '1'
  }
})
export const imgHost = {
  baseURL: process.env.VUE_APP_IMG
}
// 专利
export const patentApi = request({
  baseURL: process.env.VUE_APP_PATENTAPI,
  headers: {
    'Content-Type': 'application/json',
    'app-id': '6e70493db869874692779153d07ff7c5',
    module: 'patent',
    timestamps: new Date().getTime(),
    version: '1'
  }
})

// 运营平台
export const operateApi = request({
  baseURL: process.env.VUE_APP_OPERATEAPI,
  headers: {
    'Content-Type': 'application/json',
    'app-id': '6e70493db875294692779153d07zh7c5',
    module: 'operate',
    timestamps: new Date().getTime(),
    version: '1'
  }
})
